import { FunctionComponent } from "react";
import { Testimonial } from "../types";

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard: FunctionComponent<TestimonialCardProps> = ({ testimonial }) => (
  <div
    className="
      relative mt-4 w-full h-[90%] md:w-[400px] h-[300px] p-6 flex flex-col justify-between rounded-xl 
      border-2 border-gray-300 bg-white shadow-md transition-transform duration-300
      hover:scale-105 hover:shadow-strong hover:border-primary
      overflow-hidden
    "
  >
    {/* Optional subtle shimmer / glow behind card */}
    <span className="absolute inset-0 bg-gradient-to-r from-primary-light via-primary to-primary-light opacity-10 blur-xl animate-shimmer-slow pointer-events-none"></span>

    <TestimonialText text={testimonial.text} />
    <TestimonialAuthor author={testimonial.author} />
  </div>
);

const TestimonialText: FunctionComponent<{ text: string }> = ({ text }) => (
  <p className="text-gray-700 italic relative z-10 transition-all duration-500 ease-out hover:text-primary">
    "{text}"
  </p>
);

const TestimonialAuthor: FunctionComponent<{ author: string }> = ({ author }) => (
  <p className="font-medium text-primary text-right relative z-10 transition-transform duration-500 ease-out hover:translate-x-1">
    — {author}
  </p>
);

export default TestimonialCard;
